import { ChangeEvent, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

import { useTopicStore, useTopicViewerStore } from '@/dmdrive/topic/components/Topic/TopicStore';
import SelectField from '@/dmdrive/ui-kit/components/SelectField/SelectField';

import { ShowModel, VisualMode, VisualModeBoth } from '@carbon/dm-industrial/lib/dm-industrial';

import { LeftSidebarBlock } from '../LeftSidebar.styles';

function Visualization() {
  const { isControlDisabled } = useTopicStore();
  const { viewerSettings } = useTopicViewerStore();

  const { showModel, visualMode, visualModeBoth, apply } = viewerSettings;

  const onChangeVisualMode = useCallback(
    (e: ChangeEvent<HTMLInputElement>) =>
      apply({
        visualMode: e.target.value as unknown as VisualMode,
      }),
    [],
  );

  const onChangeVisualModeBoth = useCallback(
    (e: ChangeEvent<HTMLInputElement>) =>
      apply({
        visualModeBoth: e.target.value as unknown as VisualModeBoth,
      }),
    [],
  );

  return (
    <div>
      <LeftSidebarBlock isHeader>
        <Typography variant="h6">Visualization</Typography>
      </LeftSidebarBlock>

      <LeftSidebarBlock>
        {showModel === ShowModel.Both && (
          <SelectField
            label="Visual Mode"
            onChange={onChangeVisualModeBoth}
            value={visualModeBoth}
            size="small"
            variant="standard"
            disabled={isControlDisabled}
          >
            <MenuItem value={VisualModeBoth.NONE}>None</MenuItem>

            <MenuItem value={VisualModeBoth.NEGATIVE_POSITIVE_1}>Result to Plan</MenuItem>

            <MenuItem value={VisualModeBoth.NEGATIVE_POSITIVE_2}>Plan to Result</MenuItem>

            <MenuItem value={VisualModeBoth.POSITIVE_1}>Plan</MenuItem>

            <MenuItem value={VisualModeBoth.NEGATIVE_1}>Plan (reverse)</MenuItem>

            <MenuItem value={VisualModeBoth.POSITIVE_2}>Result</MenuItem>

            <MenuItem value={VisualModeBoth.NEGATIVE_2}>Result (reverse)</MenuItem>
          </SelectField>
        )}

        {showModel !== ShowModel.Both && (
          <SelectField
            label="Visual Mode"
            onChange={onChangeVisualMode}
            value={visualMode}
            size="small"
            variant="standard"
            disabled={isControlDisabled}
          >
            <MenuItem value={VisualMode.DISTANCE}>Distance</MenuItem>

            <MenuItem value={VisualMode.WIREFRAME}>Wireframe</MenuItem>

            <MenuItem value={VisualMode.ROUGH}>Rough</MenuItem>

            <MenuItem value={VisualMode.CURVATURE}>Curvature</MenuItem>

            <MenuItem value={VisualMode.SHADED_WIREFRAME}>Shaded Wireframe</MenuItem>

            <MenuItem value={VisualMode.SHADED_FLAT}>Shaded Flat</MenuItem>

            <MenuItem value={VisualMode.SHADED_SMOOTH}>Shaded Smooth</MenuItem>
          </SelectField>
        )}
      </LeftSidebarBlock>
    </div>
  );
}

export default observer(Visualization);
